<div class="side-top-bar {{ isSideBarSmall ? 'small-background' : '' }}">
  <section class="side-bar {{ isSideBarSmall ? 'small' : '' }}">
    <div
      class="side-bar-container {{
        isSideBarSmall ? 'small-border' : 'small-border'
      }}"
    >
      @if (!isMobile) {
        <div (click)="toggleSideBar()" class="arrow-container">
          <mat-icon [ngClass]="{ 'rotate-icon': !isSideBarSmall }"
            >menu</mat-icon
          >
        </div>
      }
      <nav>
        @for (item of navigationItems; track item) {
          <div
            [class]="
              item.class === 'highlightedBig' ||
              item.class === 'highlightedNoBig'
                ? 'nav-item-selected'
                : 'nav-item'
            "
          >
            @if (item.label === "Analisi AI") {
              <div class="horizontal-line">
                <hr />
              </div>
            }
            @if (item.class === "highlightedBig") {
              <div class="top-separator {{ item.class }}"></div>
            }
            <div
              [ngClass]="
                item.icon_path?.includes('user-yellow.svg')
                  ? 'user-class'
                  : item.label === 'Funzioni AI'
                    ? 'funzioni-ai-class-' + item.class
                    : item.label === 'Fatture'
                      ? 'fatture-class-' + item.class
                      : item.label === 'Elenco Clienti'
                        ? 'funzioni-ai-class-' + item.class
                        : item.class
              "
              (click)="navigateToCorrectPage(item)"
            >
              @if (item.icon_path && item.class === "highlightedBig") {
                <img
                  src="{{ item.icon_path }}"
                  alt="icon"
                  [class]="'icon-selected'"
                  [title]="item.label"
                />
              }
              @if (item.icon_path && item.class === "noHighlightedBig") {
                <img
                  src="{{ item.icon_path }}"
                  alt="icon"
                  [class]="'icon'"
                  [title]="item.label"
                />
              }
              @if (item.icon_path && item.class === "highlightedNoBig") {
                <img
                  src="{{ item.icon_path }}"
                  alt="icon"
                  [class]="'icon-small-selected'"
                  [title]="item.label"
                />
              }
              @if (item.icon_path && item.class === "noHighlightedNoBig") {
                <img
                  src="{{ item.icon_path }}"
                  alt="icon"
                  [class]="'icon-small'"
                  [title]="item.label"
                />
              }
              @if (!isSideBarSmall) {
                <span>
                  {{ item.label }}
                </span>
              }
            </div>
            @if (
              item.class === "highlightedBig" &&
              labelsWithBottomSeparator.includes(item.label)
            ) {
              <div class="bottom-separator {{ item.class }}"></div>
            }
            @if (
              item.label === "Funzioni AI" || item.label === "Elenco Clienti"
            ) {
              <div class="funzioni-ai-separator">
                <div class="funzioni-ai-separator-borders"></div>
              </div>
            }
          </div>
        }
        <!-- <div
        style="cursor: pointer"
        *ngFor="let item of navigationItems"
        (click)="navigateToCorrectPage(item)"
        class="{{ item.class }}"
        >
        <hr class="horizontal-line" *ngIf="item.label === 'Analisi AI'" />
        {{ item.label }}
      </div> -->
      </nav>
    </div>
  </section>
  <div class="main-top-bar">
    <div
      class="{{
        isSideBarSmall ? 'top-bar-container-small' : 'top-bar-container-small'
      }}"
    >
      <header
        class="top-bar {{ isSideBarSmall ? 'top-bar-small' : 'top-bar-small' }}"
      >
        <div class="logo">
          @if (!isMobile) {
            <img
              (click)="navigateToHomePage()"
              src="assets/imgs/psicogenius_with_border.png"
              alt="logo"
              class="img"
            />
          }
          @if (isMobile) {
            <img
              (click)="navigateToHomePage()"
              src="assets/imgs/psicogenius-small.svg"
              alt="logo"
              class="img"
            />
          }
        </div>
        <div class="search-avatar-container">
          <app-top-bar-search></app-top-bar-search>
          <div class="user-avatar" (click)="toggleUserPanel()">
            <img
              [src]="profilePicture"
              referrerPolicy="no-referrer"
              alt="avatar"
              class="avatar-image"
            />
          </div>
        </div>
        @if (showUserPanel) {
          <div class="user-panel">
            <img
              [src]="profilePicture"
              referrerPolicy="no-referrer"
              alt="avatar"
              class="avatar-image-in-user-panel"
            />
            <div
              class="user-panel-text"
              (click)="navigateToCorrectPage('Area personale')"
            >
              {{ labelService.getLabel("personal_area") }}
            </div>
            <div class="user-panel-text" (click)="navigateToCorrectPage('FAQ')">
              {{ labelService.getLabel("faq").toUpperCase() }}
            </div>
            <div class="user-panel-text" (click)="logout()">
              {{ labelService.getLabel("logout") }}
            </div>
            <hr class="user-panel-separator" />
            <div
              class="user-panel-text"
              (click)="navigateToCorrectPage('termini-di-servizio')"
            >
              {{ labelService.getLabel("Termini di Servizio") }}
            </div>
            <div
              class="user-panel-text"
              (click)="navigateToCorrectPage('informativa-privacy')"
            >
              {{ labelService.getLabel("Informativa Privacy") }}
            </div>
            <div
              class="user-panel-text"
              (click)="navigateToCorrectPage('cookie-policy')"
            >
              {{ labelService.getLabel("Cookie Policy") }}
            </div>
          </div>
        }

        <!-- dropdown menu in mobile -->
        @if (dropdownMenuVisible) {
          <div class="dropdown-menu">
            @for (item of navigationItems; track item) {
              <span
                (click)="navigateToCorrectPage(item)"
                class="{{ item.class }}"
                >{{ item.label }}</span
              >
            }
          </div>
        }
      </header>
    </div>
    <main class="main-content {{ isSideBarSmall ? 'main-content-small' : '' }}">
      <ng-content></ng-content>
    </main>
  </div>
</div>
@if (showUserPanel) {
  <div class="overlay" (click)="toggleUserPanel()"></div>
}
